import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Category } from '@entity/category';
import { CategoryService } from '@service/category.service';

export const CategoryResolve: ResolveFn<Category> = (route) => {
  return inject(CategoryService).getCategory(route.params.id);
};
